// extracted by mini-css-extract-plugin
module.exports = {"slider":"Hero_slider__3iV5b"};